module.exports = __webpack_public_path__ + "img/Muffler.9bd76de7.png";